export const GET_CUSTOM_QUESTIONS = gql`
  query GetCustomQuestions(
    $filters: CustomQuestionFiltersInput
    $pageInfo: PageInfoInput
  ) {
    customQuestions(filters: $filters, pageInfo: $pageInfo) {
      items {
        customQuestionId
        label
        key
        fieldType
        status
        placeholder
        helpText
        options {
          customQuestionOptionId
          label
          order
        }
      }
      totalCount
      pageInfo {
        limit
        offset
      }
    }
  }
`

export const GET_CUSTOM_QUESTION = gql`
  query GetCustomQuestion($id: String!) {
    customQuestion(id: $id) {
      customQuestionId
      label
      key
      fieldType
      status
      placeholder
      helpText
      options {
        customQuestionOptionId
        label
        order
      }
      createdAt
      createdBy {
        employeeId
        firstName
        lastName
      }
    }
  }
`

export const CREATE_CUSTOM_QUESTION = gql`
  mutation CreateCustomQuestion($input: CreateCustomQuestionInput!) {
    createCustomQuestion(input: $input) {
      customQuestionId
      label
      key
      fieldType
      status
    }
  }
`

export const UPDATE_CUSTOM_QUESTION = gql`
  mutation UpdateCustomQuestion(
    $id: String!
    $input: UpdateCustomQuestionInput!
  ) {
    updateCustomQuestion(id: $id, input: $input) {
      customQuestionId
      label
      key
      fieldType
      status
    }
  }
`

export const DELETE_CUSTOM_QUESTION = gql`
  mutation DeleteCustomQuestion($id: String!) {
    deleteCustomQuestion(id: $id) {
      customQuestionId
      status
    }
  }
`

export const ADD_QUESTION_TO_TEMPLATE = gql`
  mutation AddQuestionToTemplate(
    $jobListingTemplateId: String!
    $input: AddQuestionToTemplateInput!
  ) {
    addQuestionToTemplate(
      jobListingTemplateId: $jobListingTemplateId
      input: $input
    ) {
      jobListingTemplateQuestionId
      customQuestionId
      isRequired
      visibility
      order
      question {
        customQuestionId
        label
        key
        fieldType
        options {
          customQuestionOptionId
          label
          order
        }
      }
    }
  }
`

export const UPDATE_TEMPLATE_QUESTION = gql`
  mutation UpdateTemplateQuestion(
    $id: String!
    $input: UpdateTemplateQuestionInput!
  ) {
    updateTemplateQuestion(id: $id, input: $input) {
      jobListingTemplateQuestionId
      customQuestionId
      isRequired
      visibility
      order
    }
  }
`

export const BATCH_UPDATE_TEMPLATE_QUESTIONS = gql`
  mutation BatchUpdateTemplateQuestions(
    $jobListingTemplateId: String!
    $updates: [BatchUpdateTemplateQuestionInput!]!
  ) {
    batchUpdateTemplateQuestions(
      jobListingTemplateId: $jobListingTemplateId
      updates: $updates
    ) {
      jobListingTemplateQuestionId
      customQuestionId
      isRequired
      visibility
      order
    }
  }
`

export const REMOVE_QUESTION_FROM_TEMPLATE = gql`
  mutation RemoveQuestionFromTemplate($id: String!) {
    removeQuestionFromTemplate(id: $id) {
      jobListingTemplateQuestionId
    }
  }
`

export const UPDATE_APPLICATION_QUESTION_RESPONSE = gql`
  mutation UpdateApplicationQuestionResponse(
    $id: String!
    $input: UpdateApplicationQuestionResponseInput!
  ) {
    updateApplicationQuestionResponse(id: $id, input: $input) {
      applicationQuestionResponseId
      valueShortText
      valueLongText
      valueBoolean
    }
  }
`

export const BATCH_UPDATE_APPLICATION_QUESTION_RESPONSES = gql`
  mutation BatchUpdateApplicationQuestionResponses(
    $updates: [BatchUpdateApplicationQuestionResponseInput!]!
  ) {
    batchUpdateApplicationQuestionResponses(updates: $updates) {
      applicationQuestionResponseId
      valueShortText
      valueLongText
      valueBoolean
    }
  }
`

export const SYNC_APPLICATION_QUESTION_RESPONSES = gql`
  mutation SyncApplicationQuestionResponses(
    $applicationId: String!
    $applicantId: String!
    $jobListingId: String!
  ) {
    syncApplicationQuestionResponses(
      applicationId: $applicationId
      applicantId: $applicantId
      jobListingId: $jobListingId
    ) {
      applicationQuestionResponseId
      valueShortText
      valueLongText
      valueBoolean
    }
  }
`
